// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const lpName = objectOf({
  name: string,
  slug: string,
});

export const isLandingPageNamesForSelectResult = objectOf({
  results: arrayOf(lpName),
});
